/**
 * PATH: packages/ui/src/kanban/install-all-kanban-settings.ts
 * FILE_ID: UI-SETTINGS-ALL-KANBAN-INSTALL-001
 * PURPOSE: Register the real All Kanban tab without Settings importing it.
 * ROLE IN ARCHITECTURE: Kanban-host boot side effect.
 * MAIN EXPORTS: installAllKanbanSettingsTab, registerKanbanSettingsApiProvider
 * NON-RESPONSIBILITIES: Does not mount Settings or invent a prefs API.
 * NOTES FOR FUTURE AI: Import this from kanban-host boot, not from @quotech/ui.
 */

import { AllKanbanSettingsTab } from '../components/settings/AllKanbanSettingsTab'
import { registerAllKanbanSettingsTab } from '../components/settings/allKanbanSettingsTabRegistry'

export { registerKanbanSettingsApiProvider } from './components/settings-home/kanbanSettingsHost'

/** Bind the gear Settings All Kanban body. Idempotent. */
export function installAllKanbanSettingsTab(): void {
  registerAllKanbanSettingsTab(AllKanbanSettingsTab)
}
